import React from 'react'
import dynamic from 'next/dynamic'
import Experiment from '@mc/experiments-react'
import { HP_INNOVATIVE_SWING_FLAG_NAME } from '../constants'

const Variant = dynamic(
  () => import('./BelowTheFoldVariant').then((m) => m.BelowTheFoldVariant),
  {
    ssr: false,
  },
)

interface BelowTheFoldExpWrapperProps {
  Control: React.ReactNode
}

export const BelowTheFoldExpWrapper = ({
  Control,
}: BelowTheFoldExpWrapperProps) => (
  <Experiment
    name={HP_INNOVATIVE_SWING_FLAG_NAME}
    control={() => Control}
    variant_1={Variant}
    track={false}
  />
)
